import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormFolderFilter, { FORM_FOLDER_FILTER_ID } from '../forms/FormFolderFilter';
import { useTranslation } from 'react-i18next';

export default function SheetFolderFilter({ open, onClose, onSubmit, filters, collaborators, subsidiaries }) {
    const { t } = useTranslation();
    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! lg:w-[640px]! flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('folders:filtrerEtTrier')}</SheetTitle>
                </SheetHeader>

                <FormFolderFilter
                    collaborators={collaborators}
                    subsidiaries={subsidiaries}
                    filters={filters}
                    onSubmit={onSubmit}
                />

                <SheetFooter className="px-6 py-4 border-t border-border">
                    <SubmitButton form={FORM_FOLDER_FILTER_ID} className="w-full px-4 py-3 rounded-lg">
                        {t('folders:appliquer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
